var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39062 0C3.07812 0 2 1.07812 2 2.39062V27.6094C2 28.9219 3.07812 30 4.39062 30H25.8594C27.125 30 28.2031 28.9219 28.2031 27.6094V9.51562L19.3438 0H4.39062V0Z",
    fill: "#FFC35E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2031 9.5625V10.0312H22.2031C22.2031 10.0312 19.25 9.42188 19.3438 6.84375C19.3438 6.84375 19.4375 9.5625 22.1563 9.5625H28.2031Z",
    fill: "#FFB446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3438 0V6.84375C19.3438 7.59375 19.8594 9.5625 22.2031 9.5625H28.2031L19.3438 0H19.3438Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4219 25.2656C11.2812 25.2656 11.1406 25.1719 11.0938 25.0312L10.6719 24H7.85938L7.4375 25.0312C7.39062 25.1719 7.25 25.2656 7.10938 25.2656C6.92188 25.2656 6.73438 25.0781 6.73438 24.8906C6.73438 24.8438 6.73438 24.7969 6.78125 24.75L8.70312 19.9219C8.79688 19.6875 9.03125 19.5469 9.26562 19.5469C9.54688 19.5469 9.73438 19.6875 9.82812 19.9219L11.7969 24.75V24.8906C11.7969 25.0781 11.6562 25.2656 11.4219 25.2656ZM9.26562 20.3438L8.09375 23.3438H10.4844L9.26562 20.3438ZM12.9219 24.9375C12.9219 25.125 13.0625 25.2656 13.25 25.2656C13.4844 25.2656 13.625 25.125 13.625 24.9375V19.875C13.625 19.6875 13.4844 19.5469 13.2969 19.5469C13.0625 19.5469 12.9219 19.6875 12.9219 19.875V24.9375Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/Ai.a5fa94d5514ae65cbc54554eb29f7881.svg";
export { ForwardRef as ReactComponent };